<template>
  <NoticeModalDetailModal
    :isOpen="openModal"
    :close="closeModal"
    :reload="reload"
    :selectedPopup="selectModal"
    v-if="openModal"
  />
  <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
    <b-row class="my-4 min-width-full align-items-center">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="제목 또는 내용을 입력하세요."
            v-model="search.title"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="8" class="text-right">
        <Button :type="BadgeTypes.purple" label="등록" :on-click="openNewModal"/>
      </b-col>
    </b-row>
    <b-table :fields="fields" :items="noticeModals" class="text-left">
      <template #cell(title)="data">
        <span class="mr-2">{{data.item.title}}</span>
      </template>
      <template #cell(active)="data">
        <b-badge variant="success" v-if="data.item.active === true">
          {{"노출"}}
        </b-badge>
        <b-badge variant="danger" v-if="data.item.active !== true">
          {{"비노출"}}
        </b-badge>
      </template>
      <template #cell(period)="data">
        {{ formatPeriod(data.item.startDate, data.item.endDate) }}
      </template>
      <template #cell(closable)="data">
        <b-badge variant="success" v-if="data.item.closable === true">
          {{"가능"}}
        </b-badge>
        <b-badge variant="danger" v-if="data.item.closable !== true">
          {{"불가"}}
        </b-badge>
      </template>
      <template #cell(button)="data">
        <div class="inline-flex gap-2 justify-end items-center text-right w-full">
          <Button :type="ButtonTypes.blue" label="상세" :onClick="() => setDetail(data.item)" />
          <Button :type="ButtonTypes.red" label="삭제" :onClick="() => deleteModal(data.item.id)" />
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="pageSize"
      @page-click="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api";
import {BadgeTypes, ButtonTypes} from "@/util/enums";
import Button from "@/components/Button.vue";
import customDate from "@/util/custom-date";
import NoticeModalDetailModal from "@/components/modals/NoticeModalDetailModal.vue";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    BadgeTypes() {
      return BadgeTypes
    },
  },
  components: {NoticeModalDetailModal, Button},
  data() {
    return {
      searchLessons: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      openModal: false,
      selectedLesson: {},
      fields: [
        {
          label: '제목',
          key: 'title',
        },
        {
          label: '노출 기간',
          key: 'period',
        },
        {
          label: '노출여부',
          key: 'active',
        },
        {
          label: '닫기 가능',
          key: 'closable',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      noticeModals: [],
      search: {
        title: "",
        checkDeleted: false
      },
      selectModal: null,
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.title = query.keyword
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    closeModal() {
      this.selectModal = null
      this.openModal = false
    },
    openNewModal() {
      this.selectModal = null
      this.openModal = true
    },
    setDetail(selectModal) {
      this.selectModal = selectModal
      this.openModal = true
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      
      this.$router.replace({ query })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    formatPeriod(startDate, endDate) {
      const start = startDate ? this.getDate(startDate) : ''
      const end = endDate? this.getDate(endDate) : ''

      if (!start && !end) return ''
      if (!start) return `~ ${end}`
      if (!end) return `${start} ~`

      return `${start} ~ ${end}`
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    deleteModal(id){
      api.noticeModal.delete(id,(response) => {
        this.getPagingList(this.currentPage)
      }, (err) => {
        console.log(err)
      })
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.title,
      }
      
      api.noticeModal.search(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.noticeModals = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>